import { OrganizationConfig } from '@tenants/types/tenant';


export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return null;
    },
    email() {
      return null;
    },
    address() {
      return null;
    },
    twitterUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    linkedinUrl: '',
  };
}
